/**
 * 租赁管理
 */

import request from '@/utils/request'

// 客户管理
export const customerInfoPage = (data = {}) => request({ url: '/api/estate/v1/customer/customerInfoPage', method: 'post', data })

export const customerInfoCount = (data = {}) => request({ url: '/api/estate/v1/customer/customerInfoCount', method: 'post', data })

export const customerInfoDetail = (data = {}) => request({ url: '/api/estate/v1/customer/customerInfoDetail', method: 'post', data })

export const customerPersonInfoIns = (data = {}) => request({ url: '/api/estate/v1/customer/customerPersonInfoIns', method: 'post', data })

export const customerCompanyInfoIns = (data = {}) => request({ url: '/api/estate/v1/customer/customerCompanyInfoIns', method: 'post', data })

export const customerInfoUpd = (data = {}) => request({ url: '/api/estate/v1/customer/customerInfoUpd', method: 'post', data })

export const customerInfoDel = (data = {}) => request({ url: '/api/estate/v1/customer/customerInfoDel', method: 'post', data })

export const customerInfoDelBatch = (data = {}) => request({ url: '/api/estate/v1/customer/customerInfoDelBatch', method: 'post', data })

export const customerInfoRelationalContract = (data = {}) => request({ url: '/api/estate/v1/customer/customerInfoRelationalContract', method: 'post', data })

// 租赁合同
export const rentContractInfoPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoPage', method: 'post', data })

export const rentContractInfoCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoCount', method: 'post', data })

export const rentContractInfoDel = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoDel', method: 'post', data })

export const rentContractInfoDelBatch = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoDelBatch', method: 'post', data })

export const rentContractInfoDetail = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoDetail', method: 'post', data })

export const rentContractInfoIns = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoIns', method: 'post', data })

export const rentContractInfoUpd = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoUpd', method: 'post', data })

export const rentContractRoomUpd = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractRoomUpd', method: 'post', data })

export const rentContractChargeUpd = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractChargeUpd', method: 'post', data })

export const rentContractChargeBatchUpd = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractChargeBatchUpd', method: 'post', data })

export const rentContractChargeDel = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractChargeDel', method: 'post', data })

export const rentContractLeaseRenewal = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractLeaseRenewal', method: 'post', data })

export const rentContractInfoOperateRecordPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoOperateRecordPage', method: 'post', data })

export const rentContractInfoOperateRecordCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoOperateRecordCount', method: 'post', data })

export const operateDetail = (data = {}) => request({ url: '/api/estate/v1/commerce/operateDetail', method: 'post', data })

export const rentContractSublet = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractSublet', method: 'post', data })

export const rentContractRoomBack = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractRoomBack', method: 'post', data })

export const rentContractParkingSpaceUpd = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractParkingSpaceUpd', method: 'post', data })

// 收款计划
export const rentContractTollPlanPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractTollPlanPage', method: 'post', data })

export const rentContractTollPlanCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractTollPlanCount', method: 'post', data })

export const rentContractTollPlanDetail = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractTollPlanDetail ', method: 'post', data })

// 收款记录
export const rentContractTollRecordPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractTollRecordPage', method: 'post', data })

export const rentContractTollRecordCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractTollRecordCount', method: 'post', data })

export const rentContractTollRecordDetail = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractTollRecordDetail', method: 'post', data })

export const rentContractTollRecordStatistic = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractTollRecordStatistic', method: 'post', data })

export const changeStatus = (data = {}) => request({ url: `/api/estate/v1/commerce/changeStatus`, method: 'post', data })

export const setFinishCheck = (data = {}) => request({ url: `/api/estate/v1/commerce/setFinishCheck`, method: 'post', data })

export const cancelFinishCheck = (data = {}) => request({ url: `/api/estate/v1/commerce/cancelFinishCheck`, method: 'post', data })

// 合同报表
export const rentContractReceivableAmountReport = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableAmountReport', method: 'post', data })

export const rentContractReceivableCommunityReport = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableCommunityReport ', method: 'post', data })

export const rentContractReceivableItemReport = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableItemReport ', method: 'post', data })

export const voidCheckPayment = (data = {}) => request({ url: '/api/estate/v1/commerce/voidCheckPayment ', method: 'post', data })

export const rentPaymentDetailsInfoPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentPaymentDetailsInfoPage', method: 'post', data })

export const rentPaymentDetailsInfoCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentPaymentDetailsInfoCount ', method: 'post', data })

export const rentContractReceivableOrderAmountPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableOrderAmountPage ', method: 'post', data })

export const rentContractReceivableOrderAmountCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableOrderAmountCount ', method: 'post', data })

export const rentContractReceivablePreferentialAmountPage = (data = {}) =>
  request({ url: '/api/estate/v1/commerce/rentContractReceivablePreferentialAmountPage ', method: 'post', data })

export const rentContractReceivablePreferentialAmountCount = (data = {}) =>
  request({ url: '/api/estate/v1/commerce/rentContractReceivablePreferentialAmountCount ', method: 'post', data })

export const rentContractReceivableRealAmountPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableRealAmountPage ', method: 'post', data })

export const rentContractReceivableRealAmountCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableRealAmountCount ', method: 'post', data })

export const rentContractReceivableRefundAmountPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableRefundAmountPage ', method: 'post', data })

export const rentContractReceivableRefundAmountCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableRefundAmountCount ', method: 'post', data })

export const rentContractReceivableUnpaidAmountPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableUnpaidAmountPage ', method: 'post', data })

export const rentContractReceivableUnpaidAmountCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableUnpaidAmountCount ', method: 'post', data })

export const rentContractInfoOperateRecordDetail = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractInfoOperateRecordDetail ', method: 'post', data })

// 合同报表-收款情况
export const rentContractReceivableConditionReport = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractReceivableConditionReport ', method: 'post', data })

// 收据
export const getCommerceReceiptImg = (params = {}) => request({ url: `/api/estate/v1/commerce/getReceiptImg`, method: 'get', params, responseType: 'blob' })
// 普通的 退款收据
export const getfinanceReceiptRefundImg = (params = {}) => request({ url: `/api/estate/v1/finance/getReceiptRefundImg`, method: 'get', params, responseType: 'blob' })
// 商业的退款收据
export const getCommerceReceiptRefundImg = (params = {}) => request({ url: `/api/estate/v1/commerce/getReceiptRefundImg`, method: 'get', params, responseType: 'blob' })

// 优惠审批
export const flowCommerceOrderPreferentialPage = (data = {}) => request({ url: '/api/estate/v1/workflow/flowCommerceOrderPreferentialPage', method: 'post', data })

export const flowCommerceOrderPreferentialCount = (data = {}) => request({ url: '/api/estate/v1/workflow/flowCommerceOrderPreferentialCount', method: 'post', data })

export const flowApplyCommercePreInfo = (data = {}) => request({ url: '/api/estate/v1/workflow/flowApplyCommercePreInfo', method: 'post', data })

// 退款审批

export const flowCommerceRefundApplyPage = (data = {}) => request({ url: '/api/estate/v1/workflow/flowCommerceRefundApplyPage', method: 'post', data })

export const flowCommerceRefundApplyCount = (data = {}) => request({ url: '/api/estate/v1/workflow/flowCommerceRefundApplyCount', method: 'post', data })

export const flowApplyCommerceRefundInfo = (data = {}) => request({ url: '/api/estate/v1/workflow/flowApplyCommerceRefundInfo', method: 'post', data })

//优惠记录
export const rentContractOrderPreferentialPage = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractOrderPreferentialPage', method: 'post', data })

export const rentContractOrderPreferentialCount = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractOrderPreferentialCount', method: 'post', data })

export const rentContractOrderPreferentialDetail = (data = {}) => request({ url: '/api/estate/v1/commerce/rentContractOrderPreferentialDetail', method: 'post', data })

// 退款记录

export const flowCommerceOrderRefundPage = (data = {}) => request({ url: '/api/estate/v1/workflow/flowCommerceOrderRefundPage', method: 'post', data })

export const flowCommerceOrderRefundCount = (data = {}) => request({ url: '/api/estate/v1/workflow/flowCommerceOrderRefundCount', method: 'post', data })

export const flowCommerceOrderRefundDetail = (data = {}) => request({ url: '/api/estate/v1/workflow/flowCommerceOrderRefundDetail', method: 'post', data })

export const refundCommerceStatistic = (data = {}) => request({ url: '/api/estate/v1/workflow/refundCommerceStatistic', method: 'post', data })

export const refundCommerceConfirmation = (data = {}) => request({ url: '/api/estate/v1/workflow/refundCommerceConfirmation', method: 'post', data })


// 财务作废
export const financeCancelDetailPage = (data = {}) => request({ url: '/api/estate/v1/workflow/financeCancelDetailPage', method: 'post', data })

export const financeCancelDetailCount = (data = {}) => request({ url: '/api/estate/v1/workflow/financeCancelDetailCount', method: 'post', data })

export const financeCancelDetail = (data = {}) => request({ url: '/api/estate/v1/workflow/financeCancelDetail', method: 'post', data })
